module.exports = __webpack_public_path__ + "img/Governmentlogo.8e55f04c.png";